/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicySortCriteria {
    getFixupPrototypeFunction() { return PolicySortCriteria.fixupPrototype; }

    static newInstance(model: Partial<PolicySortCriteria>): PolicySortCriteria {
        let obj = Object.assign(new PolicySortCriteria(), model);
        PolicySortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicySortCriteria>): PolicySortCriteria {
        if (!model) return null;
        return PolicySortCriteria.newInstance(<PolicySortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicySortCriteria) {
        if (!obj) return;

        models.PolicySortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicySortCriteria): boolean {
        Object.setPrototypeOf(obj, PolicySortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.PolicySortColumn;

    ascending: boolean;

}
